import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { assignableStaffLocations } from '../../../../utils/locations'

function LocationChange({ userData, fetchUser, setShowLocationChange }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [role, setRole] = useState(userData.location)

  async function changeRole() {
    const data = {
      location: role,
    }
    setCancelLoading(true)
    put(`admin/change-location/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Admin Location Updated')
          setShowLocationChange(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Change Agent Location</h1>
        <p>Note: this will change the agent location </p>
        <select
          name=''
          id=''
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value=''>-select-</option>
          {assignableStaffLocations(userData.location).map((loc) => (
            <option key={loc.value} value={loc.value}>
              {loc.retired ? `${loc.label} (retired)` : loc.label}
            </option>
          ))}
        </select>
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowLocationChange(false)}>Cancel</button>
            <button className='proceed' onClick={changeRole}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default LocationChange
